import React, { useState, useEffect } from "react";
import Tree from "rc-tree";
import "rc-tree/assets/index.css";
import { Modal } from "react-bootstrap";
import DanhSachNhanVienApi from "service/danhSachNhanVienApi";
import { pushNotification } from "utils/notifications";
import { layCauHinhPhanQuyenTTKH } from "utils/quyenNguoiDung";

// Nhóm quyền "Thông tin khách vay" (cấu hình isPhanQuyenThongTinKhachHang):
// chọn các quyền này KHÔNG kéo theo quyền của tab cha ("Quản lý khách hàng"),
// vì chúng chỉ ẩn/hiện tab trong form khách hàng chứ không mở menu.
const QUYEN_THONG_TIN_KHACH_VAY = 80060;
// 80064 / 80065 là quyền con của tab "Thông tin khác" / "Thành phần gia đình"
const QUYEN_THONG_TIN_KHACH_VAY_CON = [80061, 80062, 80063, 80064, 80065];

export const PhanQuyenNhom = (props) => {
  const [nhomQuyen, setNhomQuyen] = useState("shopadmin1");
  const [lstChucNang1, setLstChucNang1] = useState([]);
  const [capNhatAll, setCapNhatAll] = useState(false);
  const [lstChucNangQuyen, setLstChucNangQuyen] = useState([]);
  const [lstQuyen, setLstQuyen] = useState([]);
  const [checkedKeys, setCheckedKeys] = useState([]);
  const [tabActive, setTabActive] = useState(0);
  const [checkALL, setCheckALL] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [batPhanQuyenTTKH, setBatPhanQuyenTTKH] = useState(false);

  useEffect(() => {
    layCauHinhPhanQuyenTTKH().then(setBatPhanQuyenTTKH);
  }, []);

  const onChangeData = (field, event) => {
    danhSachChucNangDaChon(event.target.value);
    setNhomQuyen(event.target.value);
  };

  useEffect(() => {
    if (isLoading) {
      danhSachChucNang();
      danhSachChucNangDaChon("shopadmin1");
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    if (lstChucNang1.length > 0) {
      console.log("lstChucNang1[0]lstChucNang1[0]", lstChucNang1[0]);
      setActiveTab(lstChucNang1[0].Id);
    }
  }, [lstChucNangQuyen]);

  const danhSachChucNang = () => {
    DanhSachNhanVienApi.danhsachchucnang().then((response) => {
      if (response.status == "200") {
        // Cắt mảng thành 2 phần
        const firstPart = response.data.List;
        if (response.data.ListQuyen != null) {
          setLstChucNang1(firstPart);
          setLstChucNangQuyen(response.data.ListQuyen.filter(item => item.Code !== 'danhsachcuahang'));
        }
      }
    });
  };

  const LuuPhanQuyenNhom = () => {
    console.log("setCheckedKeys", checkedKeys);
    DanhSachNhanVienApi.luuquyentheonhom(
      nhomQuyen,
      checkedKeys,
      capNhatAll
    ).then((response) => {
      if (response.data.Error == 0) {
        danhSachChucNangDaChon(nhomQuyen);
        pushNotification(response.data.Message, "success", "TOP_CENTER", 1000);
      } else
        pushNotification(response.data.Message, "error", "TOP_CENTER", 1000);
    });
  };

  const danhSachChucNangDaChon = (role) => {
    DanhSachNhanVienApi.danhsachquyentheonhom(role).then((response) => {
      if (response.status === 200) {
        // API trả về danh sách quyền được chọn
        const list = response.data.List || [];
        console.log("list quyền đã chọn:", list);
        // ✅ Lấy danh sách key (Code) dạng string
        const keys = list.map((x) => x.ModuleId);

        // ✅ Cập nhật state checkedKeys
        setCheckedKeys(keys);

        console.log("Danh sách quyền đã chọn:", keys);
      }
    });
  };

  const setActiveTab = (id) => {
    console.log("setActiveTab", id);
    if (lstChucNangQuyen.length == 0) {
      console.warn("lstChucNangQuyen chưa có dữ liệu!");
      return;
    }

    // Bỏ chọn CheckAll khi đổi tab
    setCheckALL(false);
    // Lọc danh sách quyền thuộc tab này
    let list = lstChucNangQuyen.filter((x) => x.IdParent === id);
    // Map sang cấu trúc TreeNode
    const tree = list.map((x) => ({
      title: x.Name,
      key: x.Id,
      children: lstChucNangQuyen
        .filter((child) => child.IdParent === x.Id)
        .map((child) => ({
          title: child.Name,
          key: child.Id,
          //Cấp 3: quyền con của quyền con (vd "Ghi chú" trong tab "Thông tin khác")
          children: lstChucNangQuyen
            .filter((chau) => chau.IdParent === child.Id)
            .map((chau) => ({
              title: chau.Name,
              key: chau.Id,
            })),
        })),
    }));

    setTabActive(id);
    setLstQuyen(tree);

    const listKeysInTab = list.map((x) => x.Id);
    const isAllChecked = listKeysInTab.every((key) =>
      checkedKeys.includes(key)
    );

    setCheckALL(isAllChecked);
    // setCapNhatAll(false);
  };

  const getAllKeysInTree = (tree) => {
    let keys = [];
    tree.forEach((node) => {
      keys.push(node.key);
      if (node.children) {
        keys = keys.concat(getAllKeysInTree(node.children));
      }
    });
    return keys;
  };
  const getAllChildIds = (rootId) => {
    let result = [rootId];
    let queue = [rootId];

    while (queue.length > 0) {
      const parentId = queue.shift();

      // tìm con trực tiếp
      const children = lstChucNangQuyen
        .filter((x) => x.IdParent === parentId)
        .map((x) => x.Id);

      for (const child of children) {
        if (!result.includes(child)) {
          result.push(child);
          queue.push(child);
        }
      }
    }

    return result;
  };

  // ✅ Chọn tất cả / bỏ tất cả trong tab
  const handleCheckAll = (e, index) => {
    if (!tabActive) return;
    // Lấy tất cả key của quyền trong tab hiện tại
    // const listKeysInTab = lstChucNangQuyen
    //   .filter((x) => x.IdParent === tabActive || x.Id === tabActive)
    //   .map((x) => x.Id);
    const listKeysInTab = getAllChildIds(tabActive);
    // hoặc x.Code nếu key Tree dùng Code
    console.log("listKeysInTab", listKeysInTab);
    if (e.target.checked) {
      // ✅ thêm các key của tab vào danh sách checked (loại trùng)
      const merged = Array.from(new Set([...checkedKeys, ...listKeysInTab]));
      setCheckedKeys(merged);
    } else {
      // ✅ bỏ các key của tab khỏi danh sách checked
      const filtered = checkedKeys.filter(
        (key) => !listKeysInTab.includes(key)
      );
      console.log("filtered", filtered);
      setCheckedKeys(filtered);
    }
    setCheckALL(e.target.checked);

    console.log("checkedKeys", checkedKeys);
  };

  const handleCheckMenu = (key) => {
    console.log("key", key);
    if (!checkedKeys.includes(key)) {
      setCheckedKeys([...checkedKeys, key]);
    } else {
      const filtered = checkedKeys.filter((k) => k !== key);
      setCheckedKeys(filtered);
    }
  };

  const getAllKeys = (node) => {
    let keys = [node.key];
    if (node.children) {
      node.children.forEach((c) => {
        keys = keys.concat(getAllKeys(c));
      });
    }
    return keys;
  };

  const handleCheckParent = (parent) => {
    const isChecked = checkedKeys.includes(parent.key);

    let newList = [...checkedKeys];

    if (isChecked) {
      // Uncheck parent nhưng KHÔNG đụng đến child
      newList = newList.filter((k) => k !== parent.key);
      setCheckALL(false);
    } else {
      // Check parent nhưng KHÔNG check child
      newList.push(parent.key);
    }
    const hasAny = lstQuyen.some((q) => newList.includes(q.key));
    console.log("Có ít nhất 1 quyền được chọn:", hasAny);
    console.log(
      "checkedKeys.includes(tabActive):",
      checkedKeys.includes(tabActive)
    );
    if (hasAny) {
      const laQuyenRiengTTKH =
        batPhanQuyenTTKH && parent.key === QUYEN_THONG_TIN_KHACH_VAY;
      if (!checkedKeys.includes(tabActive) && !laQuyenRiengTTKH)
        newList.push(tabActive);
    } else {
      newList = newList.filter((k) => k !== tabActive);
    }
    setCheckedKeys(newList);
  };

  //Quyền cấp 3: bật lên thì kéo theo quyền cha và ông, vì tắt 1 trong 2 là không còn thấy chỗ đó nữa
  const handleCheckChau = (parent, child, chau) => {
    let newList = [...checkedKeys];

    const isChecked = newList.includes(chau.key);

    if (isChecked) {
      newList = newList.filter((k) => k !== chau.key);
      setCheckALL(false);
    } else {
      newList.push(chau.key);
    }

    if (!newList.includes(child.key)) {
      newList.push(child.key);
    }
    if (!newList.includes(parent.key)) {
      newList.push(parent.key);
    }
    const hasAny = lstQuyen.some((q) => newList.includes(q.key));
    if (hasAny) {
      const laQuyenRiengTTKH =
        batPhanQuyenTTKH && QUYEN_THONG_TIN_KHACH_VAY_CON.includes(chau.key);
      if (!checkedKeys.includes(tabActive) && !laQuyenRiengTTKH)
        newList.push(tabActive);
    } else {
      newList = newList.filter((k) => k !== tabActive);
    }
    setCheckedKeys(newList);
  };

  const handleCheckChild = (parent, child) => {
    let newList = [...checkedKeys];

    const isChecked = newList.includes(child.key);

    // Toggle child
    if (isChecked) {
      newList = newList.filter((k) => k !== child.key);
      setCheckALL(false);
    } else {
      newList.push(child.key);
    }

    // Parent luôn giữ checked nếu nó đã được check
    if (!newList.includes(parent.key)) {
      newList.push(parent.key);
    }
    const hasAny = lstQuyen.some((q) => newList.includes(q.key));
    console.log("Có ít nhất 1 quyền được chọn:", hasAny);
    console.log(
      "checkedKeys.includes(tabActive):",
      checkedKeys.includes(tabActive)
    );
    if (hasAny) {
      const laQuyenRiengTTKH =
        batPhanQuyenTTKH && QUYEN_THONG_TIN_KHACH_VAY_CON.includes(child.key);
      if (!checkedKeys.includes(tabActive) && !laQuyenRiengTTKH)
        newList.push(tabActive);
    } else {
      newList = newList.filter((k) => k !== tabActive);
    }
    setCheckedKeys(newList);
  };
  return (
    <Modal
      {...props}
      size="modal-new-size modal-new-size"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-new modal fade text-left popup-detail"
    >
      <Modal.Header className="border-info">
        <h4 class="modal-title color7-bold" id="myModalLabel16">
          <span class="btn-icon-right">
            <img src="/app-assets/images/icon-donglai.png" alt="" />
          </span>
          Phân quyền
        </h4>
        <button
          type="button"
          className="close-popup-new"
          onClick={props.onHide}
        >
          <i class="mdi mdi-close"></i>
        </button>
      </Modal.Header>

      <Modal.Body>
        <div className="row ">
          <div className="col-md-6">
            <div className="form-group row">
              <label className="col-md-4 label-control color7-bold">
                Chọn nhóm
              </label>
              <div className="col-md-6">
                <select
                  name=""
                  id=""
                  className="form-control input-sm"
                  value={nhomQuyen}
                  onChange={(e) => onChangeData("nhom", e)}
                >
                  <option value="shopadmin1">Admin</option>
                  <option value="shopmanager">Quản lý</option>
                  <option value="shopuser">Nhân viên</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div className="row ">
          <div className="col-md-3">
            <div
              className="nav flex-column mt-1 bg-tab-vertical"
              role="tablist"
            >
              {lstChucNang1.map((item) => (
                <a
                  key={item.Code}
                  className={`nav-link ${
                    tabActive === item.Id ? "active" : ""
                  }`}
                  id={`base-${item.Code}`}
                  data-toggle="tab"
                  href={`#${item.Code}`}
                  onClick={() => setActiveTab(item.Id)}
                >
                  <h5 className="m-0 color7-bold">{item.Name}</h5>
                </a>
              ))}
            </div>
          </div>
          <div className="col-md-9">
            {" "}
            <div className="tab-content px-1 pt-1 bg-content-tab">
              <div
                style={{ overflow: "auto", height: "60vh" }}
                className="tab-pane active"
                id="tab994"
                aria-labelledby="base-tab2"
              >
                <div className="table-responsive table-2 form-thongbao tableFixHead">
                  <table className="table table-bordered mb-0 tableFixHead">
                    <tbody>
                      <tr>
                        {/* Cột Tất cả */}
                        <td className="text-left header-tb-phanquyen">
                          <div className="checkbox-parent-block">
                            <label className="checkbox-parent ">
                              <input
                                type="checkbox"
                                checked={checkALL || false}
                                onChange={(e) => handleCheckAll(e, 1)}
                              />{" "}
                              <span>Tất cả</span>
                            </label>
                          </div>
                        </td>

                        {/* Cột tab hiện tại */}
                        <td className="text-left header-tb-phanquyen">
                          {lstChucNangQuyen
                            .filter((x) => x.Id === tabActive)
                            .map((x) => (
                              <div key={x.Id} className="checkbox-parent-block">
                                <label className="checkbox-parent color7-bold">
                                  <input
                                    type="checkbox"
                                    checked={checkedKeys.includes(x.Id)}
                                    onChange={() => handleCheckMenu(x.Id)}
                                  />{" "}
                                  <span>Menu {x.Name}</span>
                                </label>
                              </div>
                            ))}
                        </td>
                      </tr>
                      <tr>
                        <td
                          className="text-left"
                          colSpan={2}
                          style={{ padding: "0px" }}
                        >
                          <div className="checkbox-group two-column-wrapper">
                            {lstQuyen.map((parent) => (
                              <div
                                key={parent.key}
                                className="checkbox-parent-block"
                              >
                                {/* Parent */}
                                <label className="checkbox-parent">
                                  <input
                                    type="checkbox"
                                    checked={checkedKeys.includes(parent.key)}
                                    onChange={() => handleCheckParent(parent)}
                                  />
                                  {parent.title}
                                </label>

                                {/* Children */}
                                {parent.children &&
                                  parent.children.length > 0 && (
                                    <div className="checkbox-children">
                                      {parent.children.map((child) => (
                                        <div key={child.key}>
                                          <label className="checkbox-child">
                                            <input
                                              type="checkbox"
                                              checked={checkedKeys.includes(
                                                child.key
                                              )}
                                              onChange={() =>
                                                handleCheckChild(parent, child)
                                              }
                                            />
                                            {child.title}
                                          </label>

                                          {/* Quyền con của quyền con (cấp 3) */}
                                          {child.children &&
                                            child.children.length > 0 && (
                                              <div className="checkbox-children">
                                                {child.children.map((chau) => (
                                                  <label
                                                    key={chau.key}
                                                    className="checkbox-child"
                                                  >
                                                    <input
                                                      type="checkbox"
                                                      checked={checkedKeys.includes(
                                                        chau.key
                                                      )}
                                                      onChange={() =>
                                                        handleCheckChau(
                                                          parent,
                                                          child,
                                                          chau
                                                        )
                                                      }
                                                    />
                                                    {chau.title}
                                                  </label>
                                                ))}
                                              </div>
                                            )}
                                        </div>
                                      ))}
                                    </div>
                                  )}
                              </div>
                            ))}
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer className="modal-footer button-popup-new-size">
        <fieldset className="checkboxsas">
          <label>
            <input
              type="checkbox"
              valu={capNhatAll}
              onClick={() => setCapNhatAll(!capNhatAll)}
            />{" "}
            Cập nhật tất cả các nhóm
          </label>
        </fieldset>

        <a
          className="btn btn-new-main btn-checknew"
          href={() => false}
          onClick={() => LuuPhanQuyenNhom()}
        >
          <span className="btn-icon-left">
            <i className="mdi mdi-content-save"></i>
          </span>{" "}
          Lưu quyền
        </a>

        <a
          className="btn btn-new-main btn-closenew"
          data-dismiss="modal"
          href={() => false}
          onClick={props.onHide}
        >
          <span className="btn-icon-left">
            <i className="mdi mdi-close"></i>
          </span>{" "}
          Đóng
        </a>
      </Modal.Footer>
    </Modal>
  );
};
